
  document.addEventListener("DOMContentLoaded", function () {
    const carousel = document.querySelector(".announcement-carousel");
    const items = document.querySelectorAll(".announcement-carousel-item");
    if (!carousel || items.length === 0) return;

    const intervalSeconds = parseInt(carousel.dataset.interval) || 5;
    const intervalTime = intervalSeconds * 1000;

    let current = 0;
    setInterval(() => {
      items[current].classList.remove("active");
      current = (current + 1) % items.length;
      items[current].classList.add("active");
    }, intervalTime);
  });